// Utility function to get environment variables from runtime config
// This allows us to override environment variables at runtime in Docker

export const getEnvVar = (key, defaultValue = '') => {
    // First try to get from runtime config (for Docker deployments)
    if (window.APP_CONFIG && window.APP_CONFIG[key] !== undefined) {
        return window.APP_CONFIG[key];
    }

    // Fallback to process.env (for development)
    return process.env[key] || defaultValue;
};

// Convenience functions for commonly used environment variables
export const getBackendUrl = () => getEnvVar('REACT_APP_BACK_END_URL', 'http://localhost:8080');
export const getWebRTCSignalingUrl = () => getEnvVar('REACT_APP_WEBRTC_SIGNALING_URL', 'http://localhost:8081');
export const getWebRTCApiUrl = () => getEnvVar('REACT_APP_WEBRTC_API_URL', 'http://localhost:8080');
export const getAuthTokenKey = () => getEnvVar('REACT_APP_AUTH_TOKEN_KEY', 'token');
export const getRefreshTokenKey = () => getEnvVar('REACT_APP_REFRESH_TOKEN_KEY', 'refreshToken');
export const getTokenExpiryBuffer = () => parseInt(getEnvVar('REACT_APP_TOKEN_EXPIRY_BUFFER_MINUTES', '10'));
export const getTokenValidationInterval = () => parseInt(getEnvVar('REACT_APP_TOKEN_VALIDATION_INTERVAL_SECONDS', '60'));
export const getAuthGuardCheckInterval = () => parseInt(getEnvVar('REACT_APP_AUTH_GUARD_CHECK_INTERVAL_MINUTES', '1'));
export const getHealthCheckInterval = () => parseInt(getEnvVar('REACT_APP_HEALTH_CHECK_INTERVAL_SECONDS', '15'));
export const getHealthCheckInitialDelay = () => parseInt(getEnvVar('REACT_APP_HEALTH_CHECK_INITIAL_DELAY_SECONDS', '1'));
export const getAutoLoginDelay = () => parseInt(getEnvVar('REACT_APP_AUTO_LOGIN_DELAY_SECONDS', '2'));
export const getMaxLoginAttempts = () => parseInt(getEnvVar('REACT_APP_MAX_LOGIN_ATTEMPTS', '3'));
export const getDebugMode = () => getEnvVar('REACT_APP_DEBUG_MODE', 'true') === 'true';
export const getLogLevel = () => getEnvVar('REACT_APP_LOG_LEVEL', 'debug');
export const getResetOtpResendSeconds = () => {
    const value = parseInt(getEnvVar('REACT_APP_RESET_OTP_RESEND_SECONDS', '120'), 10);
    return Number.isNaN(value) ? 120 : value;
};
export const getContactUsUrl = () => getEnvVar('REACT_APP_CONTACT_US_URL', 'https://rayzaysolutions.com/');
